module.exports = {
  base_url : process.env.base_url || "http://localhost:3000/",
  api_base_url : process.env.api_base_url || window.location.protocol+"//"+window.location.host+"/api/",
  japi_base_url : process.env.api_base_url || window.location.protocol+"//"+window.location.host+"/file/",
  app_base_url : window.location.protocol+"//"+window.location.host+"/"
};

// module.exports = {
//   base_url : process.env.base_url || "http://localhost:3000/",
//   api_base_url : process.env.api_base_url || "https://statumkpi.app/api/",
//   japi_base_url : process.env.api_base_url || "https://statumkpi.app/file/",
//   app_base_url : "https://statumkpi.app/"
// };